import TrialStatusFilterDropdownIcons from '@/assets/icons/redesign/TrialStatusFilterDropdownIcon'

export const vuetifyColors = {
  primary: '#27619F',
  secondary: '#13A6DA',
  accent: '#27619F',
  error: '#F44336',
  info: '#13A6DA',
  success: '#8BC34A',
  warning: '#FFC107',
  white: '#FFFFFF',
  light: '#F5F7FA',
  lightTwo: '#EBEDF0',
  medium: '#D2D4D6',
  mediumTwo: '#B9BABD',
  dark: '#4D4D4D',
  darkTwo: '#242424',
  menu: '#1d2529',
  sideMenuTextMuted: '#d2d4d6',
  identifiedColor: '#27619F',
  notEligibleColor: '#4D4D4D',
  notConsentedColor: '#242424',
  contingentColor: '#f3942a',
  matchedColor: '#527728',
  deceasedColor: '#F44336',
  favoritedColor: '#FDD835',
  viewedColor: '#f5f5f5',
  iconColor: '#CCCCCC',

  // redesigned color palettes
  sponsorPrimary: '#158BCB',
  sponsorSelectBlue: '#f1f5fb',
  awaitingReview: {
    primary: '#CCCCCC',
    secondary: '#E5E5E5'
  },
  inReview: {
    primary: '#845CB7',
    secondary: '#E0DAE9'
  },
  notEligible: {
    primary: '#9D325B',
    secondary: '#E1C1CD'
  },
  contingent: {
    primary: '#F19755',
    secondary: '#F8CBA9'
  },
  matched: {
    primary: '#158BCB',
    secondary: '#C4E2F1'
  },
  notConsented: {
    primary: '#E04967',
    secondary: '#F6C8D1'
  },
  enrolled: {
    primary: '#8DCB71',
    secondary: '#C6E5B7'
  }
}

const themes = {
  light: {
    ...vuetifyColors
  }
}

const options = {
  customProperties: true
}

const icons = {
  iconfont: 'md',
  values: {
    customDropdown: {
      component: TrialStatusFilterDropdownIcons
    }
  }
}

export const vuetifyConfig = {
  theme: {
    themes: themes,
    options: options
  },
  icons: icons
}
